/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack5';
import { useEffect } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import { Card, Grid, Stack, TextField, Autocomplete, Checkbox } from '@material-ui/core';
// redux
import { getProjectListByClient, resetProjectListByClient } from 'src/redux/slices/client';
import {
  createCategory,
  updateCategory,
  resetCreateFileCategoryStatus,
  resetCategoryError
} from '../../../../redux/slices/filecategory';
import { useDispatch, useSelector } from '../../../../redux/store';
import CaseConvertor from '../../../common-components/CaseConvertor';
// ----------------------------------------------------------------------

AddFileCategory.propTypes = {
  editId: PropTypes.number,
  setVisibleComponent: PropTypes.func,
  currentCategory: PropTypes.object
};

export default function AddFileCategory({ currentCategory = {}, setVisibleComponent, editId }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { error, createCategoryStatus, isLoading } = useSelector((state) => state.filecategory);
  const { clientList, projectListByClient } = useSelector((state) => state.client);

  useEffect(() => {
    if (error || createCategoryStatus) {
      enqueueSnackbar(
        (createCategoryStatus && (!editId ? 'New File Type Created Successfully' : 'File Type Updated Successfully')) ||
          (error && error),
        { variant: error ? 'error' : 'success' }
      );
      dispatch(resetCategoryError());
    }
    if (createCategoryStatus) {
      setVisibleComponent('List');
      formik.resetForm();
      dispatch(resetCreateFileCategoryStatus());
    }
  }, [error, createCategoryStatus]);

  const NewBlogSchema = Yup.object().shape({
    categoryName: Yup.string().required('Category Name is required'),
    client: Yup.mixed().required('Client Name is required'),
    project: Yup.mixed().required('Project Name is required')
  });

  const formik = useFormik({
    initialValues: {
      categoryName: editId ? currentCategory.category_name : '',
      client: editId ? currentCategory.clients : [],
      project: editId ? currentCategory.projects : []
    },
    validationSchema: NewBlogSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const clientsId = values.client.map((a) => a.id);
        const projectsId = values.project.map((a) => a.id);
        const categoryData = {
          category_name: CaseConvertor(values.categoryName),
          clients: JSON.stringify(clientsId),
          projects: JSON.stringify(projectsId)
        };
        dispatch(!editId ? createCategory(categoryData) : updateCategory(categoryData, editId));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, setFieldValue, getFieldProps } = formik;

  return (
    <>
      <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Card sx={{ p: 3, overflow: 'visible' }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="File Type"
                    required
                    {...getFieldProps('categoryName')}
                    error={Boolean(touched.categoryName && errors.categoryName)}
                    helperText={touched.categoryName && errors.categoryName}
                  />
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ mt: 3 }}>
                  <Autocomplete
                    fullWidth
                    multiple
                    name="Select Client"
                    value={values.client ? values.client : []}
                    options={clientList}
                    onChange={(e, value) => {
                      setFieldValue('project', []);
                      setFieldValue('client', value);
                      if (value) {
                        const arrayid = value.map((item) => item.id);
                        dispatch(getProjectListByClient(arrayid));
                      } else {
                        dispatch(resetProjectListByClient());
                      }
                    }}
                    disableCloseOnSelect
                    getOptionLabel={(option) => (option ? option.client_name : '')}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option.client_name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        error={Boolean(touched.client && errors.client)}
                        helperText={touched.client && errors.client}
                        required
                        {...params}
                        label="Select Client"
                        margin="none"
                      />
                    )}
                  />

                  <Autocomplete
                    fullWidth
                    multiple
                    name="Select Project"
                    value={values.project ? values.project : []}
                    options={projectListByClient}
                    onChange={(e, value) => setFieldValue('project', value)}
                    disableCloseOnSelect
                    getOptionLabel={(option) => (option ? option.project_name : '')}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option.project_name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        error={Boolean(touched.project && errors.project)}
                        helperText={touched.project && errors.project}
                        required
                        {...params}
                        label="For Project"
                        margin="none"
                      />
                    )}
                  />
                </Stack>

                <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }} md={6} xs={6}>
                  <LoadingButton type="submit" variant="contained" loading={isLoading}>
                    Save
                  </LoadingButton>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>
    </>
  );
}
